import React, { createContext, useContext, useEffect, useState } from 'react';
import { getApiUrl } from '../config/api';

const ColorSchemeContext = createContext();

export const useColorScheme = () => {
  const context = useContext(ColorSchemeContext);
  if (!context) {
    throw new Error('useColorScheme must be used within a ColorSchemeProvider');
  }
  return context;
};

export const ColorSchemeProvider = ({ children }) => {
  const [activeColorScheme, setActiveColorScheme] = useState({
    primary: '#3B82F6',
    secondary: '#10B981',
    accent: '#F59E0B',
    background: '#FFFFFF'
  });

  const fetchActiveColorScheme = async () => {
    try {
      const response = await fetch(getApiUrl('/site/active-color-scheme'));
      if (response.ok) {
        const data = await response.json();
        if (data.primary) {
          setActiveColorScheme(data);
          updateCSSVariables(data);
        }
      }
    } catch (error) {
      console.error('Error fetching active color scheme:', error);
    }
  };

  const setColorScheme = async (schemeId) => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(getApiUrl('/admin/active-color-scheme'), {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ scheme_id: schemeId })
      });

      if (response.ok) {
        const data = await response.json();
        setActiveColorScheme(data.color_scheme);
        updateCSSVariables(data.color_scheme);
      }
    } catch (error) {
      console.error('Error setting color scheme:', error);
    }
  };

  const updateCSSVariables = (colorScheme) => {
    const root = document.documentElement;
    root.style.setProperty('--color-primary', colorScheme.primary);
    root.style.setProperty('--color-secondary', colorScheme.secondary);
    root.style.setProperty('--color-accent', colorScheme.accent);
    root.style.setProperty('--color-background', colorScheme.background);
  };

  useEffect(() => {
    fetchActiveColorScheme();
  }, []);

  return (
    <ColorSchemeContext.Provider value={{
      activeColorScheme,
      setColorScheme,
      fetchActiveColorScheme
    }}>
      {children}
    </ColorSchemeContext.Provider>
  );
};